import { useMemo } from "react";
import styles from "./VenueSummary.module.scss";
import { IconPack } from "Explore/Config/Icons";
import { numberRegex } from "Explore/Utils/numberRegex";
import { DualAxes } from "@ant-design/plots";
import useDeviceCheck from "Hooks/useDeviceCheck";
import SectionTitle from "Explore/Components/SectionTitle";
import { InfoCircleOutlined } from "@ant-design/icons";

const VenueSummary = ({ summary }) => {
  const { isMobile } = useDeviceCheck();
  const { statistics, statisticByYear } = useMemo(() => {
    const allYears = Array.from(
      new Set([
        ...Object.keys(summary.data?.citation_by_year || {}),
        ...Object.keys(summary.data?.h_index_by_year || {}),
      ])
    ).sort();

    const data = allYears.map((year) => ({
      Year: year,
      Citations: summary.data?.citation_by_year[year] || 0,
      "H-index": summary.data?.h_index_by_year[year] || 0,
    }));

    return {
      statistics: [
        {
          title: "h-index",
          value: summary.data?.all_time_h_index,
          icon: IconPack.h_index,
        },
        {
          title: "citations",
          value: summary.data?.all_time_citations,
          icon: IconPack.citation,
        },
      ],
      statisticByYear: {
        height: 300,
        data: data,
        xField: "Year",
        legend: true,
        children: [
          {
            type: "line",
            yField: "Citations",
            style: {
              stroke: "#5B8FF9",
              lineWidth: 2,
            },
            axis: {
              y: {
                title: "Citations",
                style: { titleFill: "#5B8FF9" },
              },
            },
          },
          {
            type: "line",
            yField: "H-index",
            style: {
              stroke: "#5AD8A6",
              lineWidth: 2,
            },
            axis: {
              y: {
                position: "right",
                title: "H-index",
                style: { titleFill: "#5AD8A6" },
              },
            },
          },
        ],
      },
    };
  }, [summary]);

  const render = () => {
    return (
      <div className={styles["venue-summary"]}>
        <div className={styles["statistics"]}>
          {statistics.map(({ title, value, icon }) => (
            <div className={styles["statistics__item"]} key={title}>
              <div className={styles["statistics__item--icon"]}>{icon}</div>
              <div className={styles["statistics__item--content"]}>
                <p className={styles["statistics__item--value"]}>
                  {numberRegex(value)}
                </p>
                <p className={styles["statistics__item--title"]}>{title}</p>
              </div>
            </div>
          ))}
        </div>
        <div className={styles["graph"]}>
          <div className={styles["graph--item"]}>
            <p className={styles["graph--item--title"]}>Statistic By Year</p>
            <DualAxes {...statisticByYear} />
          </div>
        </div>
      </div>
    );
  };

  return (
    <div>
      {isMobile ? (
        <SectionTitle
          title="Statistics"
          icon={<InfoCircleOutlined />}
          collapsible
          defaultOpen
        >
          {render()}
        </SectionTitle>
      ) : (
        render()
      )}
    </div>
  );
};

export default VenueSummary;
